import { joiResolver } from '@hookform/resolvers/joi';
import joi from 'joi';
import { LoginFormValue } from './types';

const password = joi.string().required().min(8).max(250).messages({
  'string.empty': 'Password cannot be empty',
  'string.max': 'Password cannot be longer than 250 characters',
  'string.min': 'Password must be at least 8 characters long',
});

const username = joi
  .string()
  .email({
    tlds: {
      allow: false,
    },
  })
  .required()
  .messages({
    'string.email': 'Username must be a valid email address',
    'string.empty': 'Username cannot be empty',
  });

/**
 * Build login form validation resolver
 */
export const createResolver = () => {
  const schema = joi.object<LoginFormValue>({
    password,
    username,
  });

  return joiResolver(schema, {
    abortEarly: false,
    messages: {},
  });
};
